var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip ? _vm.tooltipOptions : null),expression:"tooltip ? tooltipOptions : null"}],staticClass:"info-tag",class:[{ 'info-tag--tooltip': _vm.tooltip }, `info-tag--${_vm.colour}`]},[_vm._v("\n  "+_vm._s(_vm.tag)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }